// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__bRoqY","container":"App_container__5PBFy","main__container":"App_main__container__Pssg8","main_content":"App_main_content__YchpR"};